import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { UserService } from '@ca/core/services';
import { environment } from '@ca/environment/environment';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { PERMISSION_APPLICATIONS, PERMISSION_MACHINELEARNING_OVERVIEW } from 'src/app/shared/constants/constants';
import { AuthenticationService } from '../../services/authentication.service';
import { WindowRef } from '../../services/window.service';

@Injectable({
    providedIn: 'root',
})
export class LandingPageGuard implements CanActivate {
    constructor(
        private authenticationService: AuthenticationService,
        private userService: UserService,
        private router: Router,
        private windowRef: WindowRef,
    ) {}

    canActivate(): Observable<boolean | UrlTree> {
        if (this.authenticationService.hasValidAccessToken()) {
            return this.userService.hasPermissions$([PERMISSION_MACHINELEARNING_OVERVIEW]).pipe(
                switchMap((hasPermissions: boolean): Observable<boolean | UrlTree> => {
                    if (hasPermissions) {
                        return of(this.router.parseUrl('ai-toolkit/overview'));
                    } else {
                        return this.userService.hasPermissions$([PERMISSION_APPLICATIONS]).pipe(
                            switchMap((hasPermissions: boolean): Observable<boolean> | Observable<UrlTree> => {
                                if (hasPermissions) {
                                    return of(this.router.parseUrl('/applications'));
                                } else {
                                    return of(false);
                                }
                            }),
                        );
                    }
                }),
            );
        } else {
            if (!this.windowRef.isLocalhost) {
                this.windowRef.nativeWindow.location.href = environment.landingPageUrl;
                return of(false);
            }
        }
        return of(true);
    }
}
